import React from 'react';
import { 
  ArrowDown,
  Minus,
  ArrowUp,
  AlertTriangle
} from 'lucide-react';

/**
 * PriorityIndicator Component
 * Displays ticket priority with color-coded badge and icon
 */
export const PriorityIndicator = ({ priority, showLabel = true }) => {
  const priorityConfig = {
    low: {
      label: 'Low',
      color: 'bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-300',
      icon: ArrowDown,
      iconColor: 'text-gray-600 dark:text-gray-400',
    },
    medium: {
      label: 'Medium',
      color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',
      icon: Minus,
      iconColor: 'text-blue-600 dark:text-blue-400',
    },
    high: {
      label: 'High',
      color: 'bg-orange-100 text-orange-800 dark:bg-orange-900/20 dark:text-orange-300',
      icon: ArrowUp,
      iconColor: 'text-orange-600 dark:text-orange-400',
    },
    urgent: {
      label: 'Urgent',
      color: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',
      icon: AlertTriangle,
      iconColor: 'text-red-600 dark:text-red-400',
    },
  };

  const config = priorityConfig[priority] || priorityConfig.medium;
  const Icon = config.icon;

  if (!showLabel) {
    // Icon only mode
    return (
      <span className={`inline-flex items-center ${config.iconColor}`} title={config.label}>
        <Icon className="w-4 h-4" />
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}
    >
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
};

export default PriorityIndicator;
